import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="13" height="12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1.29 2.11L5.18 6 1.29 9.89A.996.996 0 102.7 11.3l4.59-4.59a.996.996 0 000-1.41L2.7.7a.996.996 0 00-1.41 0c-.38.39-.38 1.03 0 1.41zM12 0c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1s-1-.45-1-1V1c0-.55.45-1 1-1z" fill="#444" /></svg>;